// import { Button } from 'react-bootstrap';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { SupplyChainNodeData } from '../../hooks/useSupplyChain';

const statusColorBySupplierStatus: Record<string, string> = {
  Unverified: '#94a3b8',
  Warning: '#f59e0b',
  Verified: '#22c55e',
  Flagged: '#ef4444',
  Expired: '#f97316',
};

export default function SupplierNode({ data }: NodeProps) {
  const supplierData = data as SupplyChainNodeData;
  const supplier = supplierData.supplier;
  const supplierStatus = supplier.compliance_status ?? 'Unverified';
  const supplierStatusColor =
    statusColorBySupplierStatus[supplierStatus] ??
    statusColorBySupplierStatus.Unverified;

  return (
    <div className="supplier-node-custom">
      <Handle type="target" position={Position.Top} />
      <button
        type="button"
        className="node-header node-header-button"
        onClick={() => supplierData.onSelectSupplier?.(supplier.id)}
      >
        <span>{supplier.company_name}</span>
      </button>
      <div className="node-body" style={{ padding: '0.9rem 1rem' }}>
        <i
          className="bi bi-circle-fill me-1"
          style={{ color: supplierStatusColor, fontSize: '0.75rem' }}
          aria-label={`Supplier status: ${supplierStatus}`}
          title={supplierStatus}
        ></i>
        <span>{supplierStatus}</span>
        {/* <Button
          size="sm"
          className="me-1"
          title="Edit supplier details"
          variant="outline-primary"
          onClick={() => supplierData.onEditSupplier?.(supplier.id)}
        >
          <i className="bi bi-pencil-square"></i>
        </Button>
        <Button
          size="sm"
          variant="outline-primary"
          title="Add a sub-supplier"
          onClick={() => supplierData.onAddSubSupplier?.(supplier.id)}
        >
          <i className="bi bi-person-plus"></i>
        </Button> */}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}
